import uuid from 'node-uuid';

class NBAPayload {
  getSplashAckPayload(isAcknowledged) {
    return { splash_acknowledged: isAcknowledged };
  }

  nbaContainerUserInteraction(insightId, offerId, behaviour) {
    return {
      transactions: [
        {
          id: uuid.v4(),
          response: {
            id: insightId,
            offer_id: offerId,
            behaviour, //'POSITIVE-ACCEPTED'
          },
        },
      ],
    };
  }
}

export default new NBAPayload();
